var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.3089 11.0679H7.82479V32.0002H1.3089V11.0679ZM4.56762 0.666016C6.65078 0.666016 8.34054 2.35578 8.34054 4.43585C8.34054 6.51592 6.65233 8.21188 4.56762 8.21188C2.4829 8.21188 0.790039 6.51901 0.790039 4.43585C0.790039 2.35268 2.47826 0.666016 4.56762 0.666016Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9075 11.0679H18.1493V13.9316H18.2344C19.1049 12.2837 21.2268 10.5506 24.3957 10.5506C30.9828 10.5506 32.1986 14.8826 32.1986 20.5203V32.0002H25.6967V21.8244C25.6967 19.3943 25.6487 16.2735 22.3156 16.2735C18.9825 16.2735 18.4126 18.9173 18.4126 21.6463V32.0002H11.9091V11.0679H11.9075Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkend);
export default __webpack_public_path__ + "static/media/linkend.5823e55f36c6927dc7dd3426b3aeb614.svg";
export { ForwardRef as ReactComponent };